module.exports = __webpack_public_path__ + "static/media/user-multiple-users-svgrepo-com.1266c6e9.svg";